import DIMS from './dimensions.js';
export var PARTS = {
    'torso': {
        name: 'torso',
        side: 'middle',
        mass: DIMS.TORSO_MASS,
        cmZ: DIMS.TORSO_CM_Z,
        dims: [DIMS.TORSO_WIDTH, DIMS.TORSO_HEIGHT, DIMS.TORSO_DEPTH],
    },
    'right-upper-arm': {
        name: 'right-upper-arm',
        side: 'right',
        mass: DIMS.UPPER_ARM_MASS,
        cmZ: -DIMS.UPPER_ARM_CM_Z,
        dims: [DIMS.UPPER_ARM_WIDTH, DIMS.UPPER_ARM_HEIGHT, DIMS.UPPER_ARM_DEPTH],
    },
    'right-lower-arm': {
        name: 'right-lower-arm',
        side: 'right',
        mass: DIMS.LOWER_ARM_MASS,
        cmZ: -DIMS.LOWER_ARM_CM_Z,
        dims: [DIMS.LOWER_ARM_WIDTH, DIMS.LOWER_ARM_HEIGHT, DIMS.LOWER_ARM_DEPTH],
    },
    'left-upper-arm': {
        name: 'left-upper-arm',
        side: 'left',
        mass: DIMS.UPPER_ARM_MASS,
        cmZ: -DIMS.UPPER_ARM_CM_Z,
        dims: [DIMS.UPPER_ARM_WIDTH, DIMS.UPPER_ARM_HEIGHT, DIMS.UPPER_ARM_DEPTH],
    },
    'left-lower-arm': {
        name: 'left-lower-arm',
        side: 'left',
        mass: DIMS.LOWER_ARM_MASS,
        cmZ: -DIMS.LOWER_ARM_CM_Z,
        dims: [DIMS.LOWER_ARM_WIDTH, DIMS.LOWER_ARM_HEIGHT, DIMS.LOWER_ARM_DEPTH],
    },
    'hip': {
        name: 'hip',
        side: 'middle',
        mass: DIMS.HIP_MASS,
        dims: [DIMS.HIP_WIDTH, DIMS.HIP_HEIGHT, DIMS.HIP_DEPTH],
    },
    'right-upper-leg': {
        name: 'right-upper-leg',
        side: 'right',
        mass: DIMS.UPPER_LEG_MASS,
        cmZ: -DIMS.UPPER_LEG_CM_Z,
        dims: [DIMS.UPPER_LEG_WIDTH, DIMS.UPPER_LEG_HEIGHT, DIMS.UPPER_LEG_DEPTH],
    },
    'right-lower-leg': {
        name: 'right-lower-leg',
        side: 'right',
        mass: DIMS.LOWER_LEG_MASS,
        cmZ: -DIMS.LOWER_LEG_CM_Z,
        dims: [DIMS.LOWER_LEG_WIDTH, DIMS.LOWER_LEG_HEIGHT, DIMS.LOWER_LEG_DEPTH],
    },
    'left-upper-leg': {
        name: 'left-upper-leg',
        side: 'left',
        mass: DIMS.UPPER_LEG_MASS,
        cmZ: -DIMS.UPPER_LEG_CM_Z,
        dims: [DIMS.UPPER_LEG_WIDTH, DIMS.UPPER_LEG_HEIGHT, DIMS.UPPER_LEG_DEPTH],
    },
    'left-lower-leg': {
        name: 'left-lower-leg',
        side: 'left',
        mass: DIMS.LOWER_LEG_MASS,
        cmZ: -DIMS.LOWER_LEG_CM_Z,
        dims: [DIMS.LOWER_LEG_WIDTH, DIMS.LOWER_LEG_HEIGHT, DIMS.LOWER_LEG_DEPTH],
    },
};
//# sourceMappingURL=parts.js.map